import styled from "styled-components";

export const Container = styled.div`
  gap: 24px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 160px 0;
`;
export const ButtonGroup = styled.div<{ twoButtons: boolean }>`
  gap: 24px;
  width: 500px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;

  ${({ twoButtons }) =>
    twoButtons
      ? ""
      : `
        & > button {
          width: auto;
          padding: 0.375em 3em;
        }
      `}
`;

export const ReverseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;
